import React from 'react';
import { get, forEach } from 'lodash';
import { IonContent } from '@ionic/react';
import { Formik } from 'formik';
import { useHistory, useLocation, Redirect, useParams } from 'react-router-dom';
import { useBasketContext } from 'src/modules/basket';
import { useTheme } from 'src/modules/card/context/theme';
import { Form, SettingField } from './Form';

export function ViewProduct({ onSubmit, product, quantity }) {
  const theme = useTheme();
  const validate = values => {
    const errors: any = {};
    if (values.options) {
      forEach(values.options, (option, i) => {
        product.settingFields.forEach(champ => {
          if (champ.label === i) {
            if (champ.required) {
              if (!option || (option && option.length === 0)) {
                if (!errors.options) {
                  errors.options = {};
                }
                errors.options[i] = 'Champs requis';
              }
            }
            if (typeof option === 'object' && option && option.length > parseInt(champ.optionsNumber, 10)) {
              if (!errors.options) {
                errors.options = {};
              }
              errors.options[i] = `Maximum ${champ.optionsNumber} choix`;
            }
          }
        });
      });
    } else if (product && product.settingFields) {
      product.settingFields.forEach(champ => {
        if (champ.required) {
          if (!errors.options) {
            errors.options = {};
          }
          errors.options[champ.label] = 'Champs requis';
        }
      });
    }
    return errors;
  };

  const initialValues = {
    id: product.id,
    settingFields: product.settingFields,
    options: product.options,
    quantity: quantity || 1,
  };

  return (
    <IonContent data-cy="product-screen" color={get(theme, 'color.background')}>
      <Formik
        validateOnMount
        initialValues={initialValues}
        onSubmit={values => {
          onSubmit(values);
        }}
        validate={validate}
      >
        {({ errors }) => (
          <Form displayQuantity={quantity !== null} entity={product} errors={errors} SettingsFieldComponent={SettingField} />
        )}
      </Formik>
    </IonContent>
  );
}

export default function Product() {
  const { addToBaskets, updateBasketsByOrderProductId, updateBaskets, getBasketById } = useBasketContext();
  const { state }: any = useLocation();
  const { id } = useParams();
  const history = useHistory();

  const product: any = state?.product;

  if (!product) return <Redirect to="/" />;

  return (
    <ViewProduct
      product={product}
      quantity={product.quantity || 1}
      onSubmit={values => {
        if (id) {
          updateBasketsByOrderProductId(id, () => ({ options: values.options, quantity: values.quantity }));
        } else if (!product.settingFields) {
          updateBaskets(values.id, () => ({ quantity: values.quantity }));
        } else {
          addToBaskets(values.id, { options: values.options, quantity: values.quantity });
        }
        history.goBack();
      }}
    />
  );
}
